<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "../../components/loader";
import api from "@/axios";
import moment from "moment/moment";
import {getBaseUrl} from "@/helpers/baseUrl";



export default {
  page: {
    title: "Mercado Livre (Lucratividade)",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
  },
  data() {
    return {
      title: "Mercado Livre (Lucratividade)",
      items: [
        {
          text: "Comercial",
          href: "/",
        },
        {
          text: "Mercado Livre (Lucratividade)",
          active: true,
        },
      ],

      updating: true,
      imgLogo: null,
      totalFat: 0,
      totalPago: 0,
      lucroBruto: 0,
      totalLucro: 0,
      totalMargem: 0,
      margemLucro: 0,
      totalPedidos: 0,

      chartData: null,
      selection: "all",
      movMeliDestaque: {},
      movMeliUltima: {},
      totalClientes: 0,
      ultimosMovs: null,
      topProdutos: null,

    };
  },

  mounted() {
    console.log('mounted dash meli')


    return api.get(`${getBaseUrl()}api/dashmeli`, {
      params: {}
    }).then(response => {
      console.log('response dash meli')
      console.log(response)

      this.imgLogo = response.data[0]
      this.totalFat = response.data[1]
      this.totalPago = response.data[2]
      this.totalPedidos = response.data[3]
      this.movMeliDestaque = response.data[7]
      this.totalClientes = response.data[8]
      this.movMeliUltima = response.data[9]
      this.ultimosMovs = response.data[11]
      this.topProdutos = response.data[12]
      this.totalLucro = response.data[13]
      this.totalMargem = response.data[14]

      this.lucroBruto = this.totalPago * 30 / 100
      this.margemLucro = this.lucroBruto / this.totalPago * 100

      this.updating = false


      this.chartData =  {
        series: [
          {
            name: "Valor Total",
            data: response.data[5],
          },
          {
            name: "Valor Pago",
            data: response.data[6],
          },
        ],
            chartoptions: {
          chart: {
            height: 350,
                type: "area",
                toolbar: {
              show: false,
            },
          },
          colors: ["#556ee6", "#f1b44c"],
              dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: "smooth",
                width: 2,
          },
          fill: {
            type: "gradient",
                gradient: {
              shadeIntensity: 1,
                  inverseColors: false,
                  opacityFrom: 0.45,
                  opacityTo: 0.05,
                  stops: [20, 100, 100, 100],
            },
          },
          xaxis: {
            categories: response.data[4],
          },
          markers: {
            size: 3,
                strokeWidth: 3,

                hover: {
              size: 4,
                  sizeOffset: 2,
            },
          },
          legend: {
            position: "top",
                horizontalAlign: "right",
          },
        },
      }


    })


  },

  methods: {



    updateData: function(timeline) {
      this.selection = timeline;
      // switch (timeline) {
      //   case "one_month":
      //     this.chartData.series = [
      //       {
      //         name: "Current",
      //         data: [12, 22, 38, 42, 32, 40, 51, 36, 51, 29, 38, 36],
      //       },
      //       {
      //         name: "Previous",
      //         data: [22, 31, 36, 26, 47, 56, 42, 64, 61, 52, 42, 31],
      //       },
      //     ];
      //     break;
      //   case "six_months":
      //     this.chartData.series = [
      //       {
      //         name: "Current",
      //         data: [31, 40, 28, 51, 42, 40, 51, 36, 40, 39, 31, 36],
      //       },
      //       {
      //         name: "Previous",
      //         data: [11, 32, 45, 32, 34, 22, 51, 60, 51, 52, 40, 31],
      //       },
      //     ];
      //     break;
      //   case "one_year":
      //     this.chartData.series = [
      //       {
      //         name: "Current",
      //         data: [28, 22, 38, 42, 32, 40, 51, 36, 51, 29, 38, 36],
      //       },
      //       {
      //         name: "Previous",
      //         data: [22, 31, 36, 26, 47, 56, 42, 64, 61, 52, 42, 31],
      //       },
      //     ];
      //     break;
      //   case "all":
      //     this.chartData.series = [
      //       {
      //         name: "Current",
      //         data: [18, 21, 45, 36, 65, 47, 51, 32, 40, 28, 31, 26],
      //       },
      //       {
      //         name: "Previous",
      //         data: [30, 11, 22, 18, 32, 23, 58, 45, 30, 36, 15, 34],
      //       },
      //     ];
      //     break;
      //   default:
      // }
    },


    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

  }

};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <div v-if="!updating">
      <div class="row">
        <div class="col-xl-8">
          <div class="row">
            <div class="col-lg-4">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Faturamento</p>
                      <h5 class="mb-0">R$ {{ formatDecimal(totalFat) }}</h5>
                    </div>

                    <div class="avatar-sm ms-auto">
                      <div
                        class="avatar-title bg-light rounded-circle text-primary font-size-20"
                      >
                        <i class="bx bxs-dollar-circle"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-4">
              <div class="card blog-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Líquidação</p>
                      <h5 class="mb-0">R$ {{ formatDecimal(totalPago) }}</h5>
                    </div>

                    <div class="avatar-sm ms-auto">
                      <div
                        class="avatar-title bg-light rounded-circle text-primary font-size-20"
                      >
                        <i class="bx bxs-building"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="card blog-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Lucro Bruto ({{ formatInteger(totalMargem) }}%)</p>
                      <h5 class="mb-0">R$ {{ formatDecimal(totalLucro) }}</h5>
                    </div>

                    <div class="avatar-sm ms-auto">
                      <div
                        class="avatar-title bg-light rounded-circle text-primary font-size-20"
                      >
                        <i class="bx bxs-memory-card"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end row -->

          <div class="card">

            <div class="card-body">
              <div class="d-flex flex-wrap">
                <h5 class="card-title me-2">Evolução Anual</h5>
                <div class="ms-auto">
                  <div class="toolbar button-items text-end">
                    <button
                        type="button"
                        class="btn btn-light btn-sm"
                        @click="updateData('all')"
                        :class="{ active: selection === 'all' }"
                    >
                      Todos
                    </button>
                    <button
                        type="button"
                        class="btn btn-light btn-sm"
                        @click="updateData('one_month')"
                        :class="{ active: selection === 'one_month' }"
                    >
                      1M
                    </button>
                    <button
                        type="button"
                        class="btn btn-light btn-sm"
                        @click="updateData('six_months')"
                        :class="{ active: selection === 'six_months' }"
                    >
                      6M
                    </button>
                    <button
                        type="button"
                        class="btn btn-light btn-sm active"
                        @click="updateData('one_year')"
                        :class="{ active: selection === 'one_year' }"
                    >
                      12M
                    </button>
                  </div>
                </div>
              </div>

              <div class="row text-center">
                <div class="col-lg-4">
                  <div class="mt-4">
                    <p class="text-muted mb-1">Hoje</p>
                    <h5>R$ {{ formatDecimal(totalPago) }}</h5>
                  </div>
                </div>

                <div class="col-lg-4">
                  <div class="mt-4">
                    <p class="text-muted mb-1">Este mês</p>
                    <h5>
                      R$ {{ formatDecimal(totalPago) }}
                      <span class="text-success font-size-13"
                      >0.0 % <i class="mdi mdi-arrow-up ms-1"></i
                      ></span>
                    </h5>
                  </div>
                </div>

                <div class="col-lg-4">
                  <div class="mt-4">
                    <p class="text-muted mb-1">Este ano</p>
                    <h5>
                      R$ {{ formatDecimal(totalPago) }}
                      <span class="text-success font-size-13"
                      >0.0 % <i class="mdi mdi-arrow-up ms-1"></i
                      ></span>
                    </h5>
                  </div>
                </div>
              </div>

              <hr class="mb-4" />

              <apexchart v-if="chartData"
                  class="apex-charts"
                  dir="ltr"
                  height="350"
                  :series="chartData.series"
                  :options="chartData.chartoptions"
              ></apexchart>
            </div>

          </div>
        </div>
        <!-- end col -->

        <div class="col-xl-4">
          <div class="card">
            <div class="card-body">
              <div class="d-flex">
                <div class="me-3">
                  <img
                      src="@/assets/images/primeiro_lugar.png"
                    alt=""
                    class="avatar-sm rounded-circle img-thumbnail"
                    style="min-height: 90px; min-width: 90px;"
                  />
                </div>
                <div class="flex-grow-1">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <div class="text-muted">
                        <h5 class="mb-1">Destaque</h5>
                        <p class="mb-0"> {{ movMeliDestaque.nickname ?? '' }} </p>
                      </div>
                    </div>

                    <router-link :to="`/pedido/pedmeli/${movMeliDestaque.id}`" class="ms-2">
                      Mais detalhes
                      <i class="mdi mdi-arrow-right ms-1"></i>
                    </router-link>

                  </div>
                  <hr />
                  <div class="row">
                    <div class="col-4">
                      <div>
                        <p class="text-muted text-truncate mb-2">Valor Pago</p>
                        <h5 class="mb-0"> R$ {{ formatDecimal(movMeliDestaque.vlrpago) }}</h5>
                      </div>
                    </div>
                    <div class="col-4">
                      <div>
                        <p class="text-muted text-truncate mb-2">Participação</p>
                        <h5 class="mb-0">{{ formatInteger(movMeliDestaque.participacao) }}%</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="card-body">
              <div class="d-flex flex-wrap">
                <h5 class="card-title mb-3 me-2">Carteira de Clientes</h5>
                <b-dropdown
                  toggle-class="text-muted font-size-16 p-0"
                  variant="white"
                  right
                  class="ms-auto"
                  menu-class="dropdown-menu-end"
                >
                  <template #button-content>
                    <i class="mdi mdi-dots-horizontal"></i>
                  </template>
                  <b-dropdown-item href="#">Acessar clientes</b-dropdown-item>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item href="#">Cadastrar novo cliente</b-dropdown-item>
                </b-dropdown>
              </div>

              <div class="d-flex flex-wrap">
                <div>
                  <p class="text-muted mb-1">Total Ativo</p>
                  <h4 class="mb-3"> {{ totalClientes }} </h4>
                  <p class="text-success mb-0">
                    <span
                      >100 % <i class="mdi mdi-arrow-top-right ms-1"></i
                    ></span>
                  </p>
                </div>
                <div class="ms-auto align-self-end">
                  <i class="bx bx-group display-4 text-light"></i>
                </div>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="card-body p-4">
              <div class="text-center">
                <div class="avatar-md mx-auto mb-4">
                  <div
                    class="avatar-title bg-light rounded-circle text-primary h1"
                  >
                    <i class="mdi mdi-shopping"></i>
                  </div>
                </div>

                <div class="row justify-content-center">
                  <div class="col-xl-10">
                    <h4 class="text-primary">Último Pedido: {{ movMeliUltima.nickname }}</h4>
                    <p class="text-muted font-size-14 mb-4">
                      {{ movMeliUltima.idorigem }}
                    </p>
                    <h5 class="text-secondary">{{ formatDateTime(movMeliUltima.created_at) }}</h5>

                    <div class="input-group bg-light rounded">
                      <input
                        id="inputIndexBlog"
                        type="number"
                        :value="movMeliUltima.vlrpago"
                        class="form-control bg-transparent border-0"
                        aria-label="Valor Pago"
                        aria-describedby="button-addon2"
                      />
                      <div class="input-group-append">
                        <button
                          class="btn btn-primary rounded"
                          type="button"
                          id="button-addon2"
                        >
                          <i class="bx bxs-folder-open"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end col -->
      </div>
      <!-- end row -->

      <div class="row">
        <div class="col-xl-12 col-lg-6">

          <div class="card">
            <div class="card-body">
              <div class="d-flex">
                <div class="me-2">
                  <h5 class="card-title mb-4">Últimos Pedidos</h5>
                </div>
                <b-dropdown
                    toggle-tag="a"
                    class="ms-auto"
                    menu-class="dropdown-menu-end"
                    toggle-class="font-size-16 p-0"
                    variant="white"
                    right
                >
                  <template #button-content>
                    <i class="mdi mdi-dots-horizontal"></i>
                  </template>
                  <b-dropdown-item href="#">Abrir pedidos</b-dropdown-item>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item href="#">Novo pedido</b-dropdown-item>
                </b-dropdown>
              </div>

              <div class="table-responsive ">
                <table class="table align-middle table-nowrap mb-0">
                  <tbody>
                  <!--            <tr>-->
                  <!--              <th scope="col" colspan="2">Post</th>-->
                  <!--              <th scope="col">Likes</th>-->
                  <!--              <th scope="col">Comments</th>-->
                  <!--              <th scope="col">Action</th>-->
                  <!--            </tr>-->

                  <tr>
                    <th class="align-middle">Cliente / Data</th>
                    <th class="align-middle text-end">Valor Pago</th>
                    <th class="align-middle text-end">Valor Lucro</th>
                    <th class="align-middle text-end">Margem (%)</th>
                    <th class="align-middle">ID</th>
                    <th class="align-middle">Status</th>
                  </tr>

                  <tr v-for="data in ultimosMovs" :key="data.id">
<!--                    <td style="width: 50px">-->
<!--                      <div class="avatar-xs me-3">-->
<!--                        <span class="avatar-title rounded-circle bg-soft bg-primary text-primary">-->
<!--                          ES-->
<!--                        </span>-->
<!--                      </div>-->
<!--                    </td>-->
                    <td>

                      <router-link :to="`/pedido/pedmeli/${data.id}`" class="ms-2">
                        <h5 class="font-size-13 text-truncate mb-1">
                          <a href="#" class="text-dark">{{ data.nickname }}</a>
                        </h5>
                        <p class="text-muted mb-0"> {{ formatDateTime(data.created_at) }} </p>
                      </router-link>

                    </td>
                    <td class="text-end"><i class="bx bx-money align-middle me-1"></i> {{ formatDecimal(data.vlrpago) }} </td>
                    <td class="text-end"><i class="bx bx-money align-middle me-1"></i> </td>
                    <td class="text-end"><i class="bx bx-money align-middle me-1"></i> </td>
                    <td><i class="bx bx-wallet align-middle me-1"></i> {{ data.idorigem }} </td>
                    <td> {{ data.status }} </td>
                    <td>
                      <b-dropdown
                          toggle-class="text-muted font-size-16 p-0"
                          menu-class="dropdown-menu-end"
                          variant="white"
                          right>
                        <template #button-content>
                          <i class="mdi mdi-dots-horizontal"></i>
                        </template>
                        <b-dropdown-item href="#">Abrir pedido</b-dropdown-item>
                        <b-dropdown-divider></b-dropdown-divider>
                        <b-dropdown-item href="#">Compartilhar</b-dropdown-item>
                      </b-dropdown>
                    </td>
                  </tr>



                  </tbody>
                </table>
              </div>
            </div>
          </div>


        </div>


      </div>


      <div class="row">
        <div class="col-xl-12">

          <div class="card">
            <div class="card-body">
              <div class="d-flex flex-wrap">
                <div class="me-2">
                  <h5 class="card-title mb-3">Produtos Destaque</h5>
                </div>
                <b-dropdown
                    class="ms-auto"
                    variant="white"
                    menu-class="dropdown-menu-end"
                    toggle-class="font-size-16 p-0"
                    right
                >
                  <template #button-content>
                    <i class="mdi mdi-dots-horizontal"></i>
                  </template>
                  <b-dropdown-item href="#">Abrir clientes</b-dropdown-item>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item href="#">Novo cliente</b-dropdown-item>
                </b-dropdown>
              </div>

              <div data-simplebar style="max-height: 310px">
                <ul class="list-group list-group-flush">






                  <li v-for="data in topProdutos" :key="data.idorigem"
                      class="list-group-item py-3" >
                    <div class="d-flex">
                      <div class="avatar-xs me-3">
                        <span class="avatar-title rounded-circle bg-soft bg-primary text-primary">
                          {{ data.contagem  }}
                        </span>
                      </div>
                      <div class="flex-grow-1">
                        <h5 class="font-size-14 mb-1">
                          {{ data.descricao }}
                          <small class="text-muted float-end">{{ data.tipolista }}</small>
                        </h5>
                        <p class="text-muted">
                          R$ {{ formatDecimal(data.sumvlrtotal) }}
                        </p>
                        <div>
                          <a href="javascript: void(0);" class="text-success"
                          ><i class="mdi mdi-reply me-1"></i> Detalhes</a
                          >
                        </div>
                      </div>
                    </div>
                  </li>




<!--                  <li class="list-group-item py-3">-->
<!--                    <div class="d-flex">-->
<!--                      <div class="avatar-xs me-3">-->
<!--                <span class="avatar-title rounded-circle bg-soft bg-primary text-primary">-->
<!--                  ES-->
<!--                </span>-->
<!--                      </div>-->
<!--                      <div class="flex-grow-1">-->
<!--                        <h5 class="font-size-14 mb-1">-->
<!--                          Cliente Testes 055-->
<!--                          <small class="text-muted float-end">20/03/2023</small>-->
<!--                        </h5>-->
<!--                        <p class="text-muted">-->
<!--                          R$ 41.400,50-->
<!--                        </p>-->
<!--                        <div>-->
<!--                          <a href="javascript: void(0);" class="text-success"-->
<!--                          ><i class="mdi mdi-reply me-1"></i> Detalhes</a-->
<!--                          >-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </li>-->


<!--                  <li class="list-group-item py-3">-->
<!--                    <div class="d-flex">-->
<!--                      <div class="avatar-xs me-3">-->
<!--                <span class="avatar-title rounded-circle bg-soft bg-primary text-primary">-->
<!--                  ES-->
<!--                </span>-->
<!--                      </div>-->
<!--                      <div class="flex-grow-1">-->
<!--                        <h5 class="font-size-14 mb-1">-->
<!--                          Cliente Testes 999-->
<!--                          <small class="text-muted float-end">20/03/2023</small>-->
<!--                        </h5>-->
<!--                        <p class="text-muted">-->
<!--                          R$ 32.185,00-->
<!--                        </p>-->
<!--                        <div>-->
<!--                          <a href="javascript: void(0);" class="text-success"-->
<!--                          ><i class="mdi mdi-reply me-1"></i> Detalhes</a-->
<!--                          >-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </li>-->


                </ul>
              </div>
            </div>
          </div>

        </div>



      </div>



    </div>


  </Layout>
</template>
